import React from 'react';
import { Info } from 'lucide-react';
import { Tooltip, TooltipTrigger, TooltipContent } from '@/designSystem/Tooltip';

export const ParametersAdjustedTooltip: React.FC = () => {
  return (
    <Tooltip>
      <TooltipTrigger>
        <div className="inline-flex items-center gap-1 px-2 py-1 bg-amber-100 text-amber-800 rounded-full text-xs cursor-help">
          <Info className="w-3 h-3" />
          <span>Adjusted</span>
        </div>
      </TooltipTrigger>
      <TooltipContent>
        <div>
          <div className="font-medium mb-1">Parameters Auto-Adjusted</div>
          <div className="text-xs opacity-90">
            We've adjusted your filters to find availability
          </div>
        </div>
      </TooltipContent>
    </Tooltip>
  );
};
